import mitt from "mitt";

export type ActionEvents = {
  called: { actionId: string };
};

/**
 * Broadcasts every CMS action call so that widgets outside of the clicked
 * control can react to it, e.g. notifications bound to an action in the CMS.
 */
export const actionEmitter = mitt<ActionEvents>();
